module.exports = __webpack_public_path__ + "img/shadow2.4f5a0d63.png";